import {Injectable}    from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {LibraryGroupDto} from "./dtos/library-group.dto";
import {UserDto} from "./dtos/user.dto";

@Injectable()
export class UserSessionService {

    get libraryId(): number { return parseInt(localStorage.getItem("libraryId")); }
    private setLibraryId(value: number) { localStorage.setItem("libraryId", String(value)); }

    get user(): Observable<UserDto> { return this._user.asObservable(); }
    setUser(user: UserDto): void { this._user.next(user); }

    get branchId(): number { return parseInt(localStorage.getItem("branchId")); }
    setBranchId(value: number) { localStorage.setItem("branchId", String(value)); }

    get library(): Observable<LibraryGroupDto> { return this._library.asObservable(); }
    setLibrary(library: LibraryGroupDto): void {

        // Clear Branch ID if Library ID is changed
        if (!library || library.id !== this.libraryId)
            this.setBranchId(null);

        this.setLibraryId(library ? library.id : null);
        this._library.next(library);
    }

    clearSession(): void {
        this._user.next(null);
        this._library.next(null);
    }

    private _user: BehaviorSubject<UserDto> = new BehaviorSubject(null);
    private _library: BehaviorSubject<LibraryGroupDto> = new BehaviorSubject(null);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/user-session.service.ts